import React from 'react';

export const MAX_DRAWER_DEPTH = 3;

const createTreeArray = (menuDefinition) => {
  const preparedTreeArray = new Array(MAX_DRAWER_DEPTH);
  preparedTreeArray.fill(null, 0, MAX_DRAWER_DEPTH);
  preparedTreeArray[0] = menuDefinition;
  return preparedTreeArray;
};

export const useMenuTreeCreator = menuDefinition => React.useCallback(
  submenusOpened => {
    const preparedTreeArray = createTreeArray(menuDefinition);
    return submenusOpened.reduce((output, current, index) => {
      const parentDefinition = output[index];
      const submenuDefinition = parentDefinition && parentDefinition[current];
      if (submenuDefinition && 'submenu' in submenuDefinition) {
        const preparedOutput = output;
        preparedOutput[index + 1] = submenuDefinition.submenu;
        return preparedOutput;
      }
      return output;
    }, preparedTreeArray);
  },
  [menuDefinition],
);
